import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CHAPTERS, CONTENT } from "../lib/content";
import { useLang } from "../lib/LangContext";
import { TID } from "../lib/testIds";

export default function ChapterIndex({ open, onClose, onGoto }) {
    const { lang } = useLang();

    return (
        <AnimatePresence>
            {open && (
                <motion.aside
                    data-testid={TID.indexPanel}
                    initial={{ x: "-100%" }}
                    animate={{ x: 0 }}
                    exit={{ x: "-100%" }}
                    transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                    className="fixed top-0 left-0 h-full w-full md:w-[520px] z-50 no-print"
                    style={{ background: "#0B0B0B", color: "#F4EFE6" }}
                >
                    <div className="flex items-center justify-between px-8 md:px-12 py-6 border-b" style={{ borderColor: "rgba(201,169,106,0.35)" }}>
                        <div className="font-micro text-[10px]" style={{ letterSpacing: "0.4em" }}>
                            {lang === "en" ? "INDEX" : "INDICE"}
                        </div>
                        <button
                            data-testid="chapter-index-close"
                            onClick={onClose}
                            className="font-micro text-[10px] link-ed"
                            style={{ color: "#F4EFE6" }}
                        >
                            {lang === "en" ? "CLOSE" : "CHIUDI"}
                        </button>
                    </div>
                    <ol className="px-8 md:px-12 py-10 space-y-5 overflow-y-auto" style={{ maxHeight: "calc(100vh - 80px)" }}>
                        {CHAPTERS.map((c, i) => {
                            const label = CONTENT[c.key]?.[lang]?.title || CONTENT[c.key]?.[lang]?.eyebrow || c.slug;
                            return (
                                <motion.li
                                    key={c.key}
                                    initial={{ opacity: 0, x: -20 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ delay: 0.1 + i * 0.03 }}
                                    className="flex items-baseline gap-6 group cursor-pointer"
                                    onClick={() => {
                                        onGoto(c.slug);
                                        onClose();
                                    }}
                                    data-testid={TID.indexItem(c.slug)}
                                >
                                    <span className="font-didone italic text-sm w-10 opacity-60 group-hover:opacity-100 transition-opacity" style={{ color: "#C9A96A" }}>
                                        {c.roman}
                                    </span>
                                    <span className="font-serif-lux text-xl md:text-2xl group-hover:text-[#C9A96A] transition-colors" style={{ lineHeight: 1.2 }}>
                                        {label}
                                    </span>
                                </motion.li>
                            );
                        })}
                    </ol>
                </motion.aside>
            )}
        </AnimatePresence>
    );
}
